import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import {
  ExternalCourseModel,
  ExternalCourseModelAPI,
} from 'models/externalCourse.model'
import {
  ExternalCoursesListParams,
  GetListResponse,
  ExternalCoursesListSort,
} from 'api/administration/externalCourses/GetList'
import { DestroyExternalCoursesAction } from '../sagas/externalCourses/destroyMany.saga'
import { ExternalCourseParticipantsListPayload } from './externalCourseParticipant.action'

export const EXTERNAL_COURSES_ADMINISTRATION_GET_LIST =
  'EXTERNAL_COURSES_ADMINISTRATION_GET_LIST'
export const EXTERNAL_COURSES_ADMINISTRATION_GET_LIST_SUCCESS =
  'EXTERNAL_COURSES_ADMINISTRATION_GET_LIST_SUCCESS'
export const EXTERNAL_COURSES_SET_LOADING = 'EXTERNAL_COURSES_SET_LOADING'
export const GET_EXTERNAL_COURSE = 'GET_EXTERNAL_COURSE'
export const EXTERNAL_COURSE_LOADING = 'EXTERNAL_COURSE_LOADING'
export const GET_EXTERNAL_COURSE_SUCCESS = 'GET_EXTERNAL_COURSE_SUCCESS'
export const EDIT_EXTERNAL_COURSE = 'EDIT_EXTERNAL_COURSE'
export const EDIT_EXTERNAL_COURSE_SUCCESS = 'EDIT_EXTERNAL_COURSE_SUCCESS'
export const DESTROY_EXTERNAL_COURSE = 'DESTROY_EXTERNAL_COURSE'
export const PUBLISH_EXTERNAL_COURSE = 'PUBLISH_EXTERNAL_COURSE'
export const DESTROY_EXTERNAL_COURSES = 'DESTROY_EXTERNAL_COURSES'
export const GET_ADMIN_EXTERNAL_COURSE = 'GET_ADMIN_EXTERNAL_COURSE'
export const EXTERNAL_COURSES_INDIVIDUAL_DOWNLOAD =
  'EXTERNAL_COURSES_INDIVIDUAL_DOWNLOAD'
export const EXTERNAL_COURSES_INDIVIDUAL_DOWNLOAD_SUCCESS =
  'EXTERNAL_COURSES_INDIVIDUAL_DOWNLOAD_SUCCESS'

export const EXTERNAL_COURSE_UPLOAD = 'EXTERNAL_COURSE_UPLOAD'
export const EXTERNAL_COURSE_UPLOAD_SUCCESS = 'EXTERNAL_COURSE_UPLOAD_SUCCESS'
export const EXTERNAL_COURSE_UPLOAD_CERTIFICATE =
  'EXTERNAL_COURSE_UPLOAD_CERTIFICATE'
export const EXTERNAL_COURSE_UPLOAD_CERTIFICATE_SUCCESS =
  'EXTERNAL_COURSE_UPLOAD_CERTIFICATE_SUCCESS'
export const EXTERNAL_COURSE_DOWNLOAD = 'EXTERNAL_COURSE_DOWNLOAD'

export interface PayloadUploadCertificatesExternalCourse {
  id: ExternalCourseModelAPI['id']
  file: File
  participantList?: ExternalCourseParticipantsListPayload
}

export interface PayloadGetExternalCourse {
  id: number | string
}

export interface DestroyExternalCoursesPayload {
  ids: ExternalCourseModelAPI['id'][]
  allSelected: boolean
  params?: ExternalCoursesListParams
  callback?(resList: GetListResponse): void
}

export const Actions = {
  setAdministrationListSuccess: (
    data: ExternalCourseModelAPI[],
    total: number,
    perPage: number,
    sort?: ExternalCoursesListSort
  ) =>
    createAction(EXTERNAL_COURSES_ADMINISTRATION_GET_LIST_SUCCESS, {
      data,
      total,
      perPage,
      sort,
    }),
  editExternalCourse: (data: ExternalCourseModel) =>
    createAction(EDIT_EXTERNAL_COURSE_SUCCESS, data),
  publishExternalCourse: (data: ExternalCourseModel) =>
    createAction(PUBLISH_EXTERNAL_COURSE, data),
  destroyExternalCourse: (payload: {
    id: number
    params?: ExternalCoursesListParams
  }) => createAction(DESTROY_EXTERNAL_COURSE, payload),
  destroyExternalCourses: (payload: DestroyExternalCoursesAction['payload']) =>
    createAction<
      typeof DESTROY_EXTERNAL_COURSES,
      DestroyExternalCoursesAction['payload']
    >(DESTROY_EXTERNAL_COURSES, payload),
  getExternalCourseLoading: (loading: boolean) =>
    createAction(EXTERNAL_COURSE_LOADING, { loading }),
  getExternalCourseSuccess: (data: ExternalCourseModel) =>
    createAction(GET_EXTERNAL_COURSE_SUCCESS, data),
  getExternalCourse: (payload: PayloadGetExternalCourse) =>
    createAction(GET_EXTERNAL_COURSE, payload),
  getList: (data?: ExternalCoursesListParams) =>
    createAction(EXTERNAL_COURSES_ADMINISTRATION_GET_LIST, data),
  getAdminExternalCourse: (payload: PayloadGetExternalCourse) =>
    createAction(GET_ADMIN_EXTERNAL_COURSE, payload),
  individualDownloadSuccess: (externalCourseId: number) =>
    createAction(
      EXTERNAL_COURSES_INDIVIDUAL_DOWNLOAD_SUCCESS,
      externalCourseId
    ),
  uploadFileSuccess: (data: any) =>
    createAction(EXTERNAL_COURSE_UPLOAD_SUCCESS, data),
  setLoading: (loading: boolean) =>
    createAction(EXTERNAL_COURSES_SET_LOADING, { loading }),
  uploadFile: (file: File) => createAction(EXTERNAL_COURSE_UPLOAD, file),
  uploadCertificates: (payload: PayloadUploadCertificatesExternalCourse) =>
    createAction(EXTERNAL_COURSE_UPLOAD_CERTIFICATE, payload),
  uploadCertificatesSuccess: (data: any) =>
    createAction(EXTERNAL_COURSE_UPLOAD_CERTIFICATE_SUCCESS, data),
  downloadExternalCourses: (payload: PayloadGetExternalCourse) =>
    createAction(EXTERNAL_COURSE_DOWNLOAD, payload),
}

export type Actions = ActionsUnion<typeof Actions>
